import dynamic from "next/dynamic";

import { useProWorkspace } from "@/features/pro-buyer-workspaces/components/workspace-context";

/*
 * WHO-6629. What shared pages mount: each slot reads the workspace context
 * (no Apollo behind it) and loads the real component only for a Pro Buyer
 * inside the gate. Everyone else renders nothing and downloads nothing, and
 * the shared components' tests never load a GraphQL document.
 */

const PdpProjectChip = dynamic(
  () =>
    import("@/features/pro-buyer-workspaces/components/PdpProjectChip").then(
      module => module.PdpProjectChip
    ),
  { ssr: false }
);
const ProjectsDashboardBlock = dynamic(
  () =>
    import(
      "@/features/pro-buyer-workspaces/components/dashboard/ProjectsDashboardBlock"
    ).then(module => module.ProjectsDashboardBlock),
  { ssr: false }
);
const CartLineProjectField = dynamic(
  () =>
    import(
      "@/features/pro-buyer-workspaces/components/cart/CartLineProjectField"
    ).then(module => module.CartLineProjectField),
  { ssr: false }
);
const ProjectFavoritesCount = dynamic(
  () =>
    import(
      "@/features/pro-buyer-workspaces/components/project/ProjectFavoritesCount"
    ).then(module => module.ProjectFavoritesCount),
  { ssr: false }
);

/** Product page: "In 2 projecten" for a piece that already is a favorite. */
export const PdpProjectChipSlot = ({
  product,
}: {
  product: { id: string; favorite?: { id: string } | null };
}) => (useProWorkspace().enabled ? <PdpProjectChip product={product} /> : null);

/** Dashboard: "Je Pro Buyer-projecten" (R11/R16). */
export const ProjectsDashboardBlockSlot = () =>
  useProWorkspace().enabled ? <ProjectsDashboardBlock /> : null;

/** Cart: the project a line is bought for (R9). FULL access only. */
export const CartLineProjectFieldSlot = ({
  cartItemId,
}: {
  cartItemId: string;
}) =>
  useProWorkspace().canEdit ? (
    <CartLineProjectField cartItemId={cartItemId} />
  ) : null;

/**
 * Projects overview card: "12 favorieten · " before the purchases (R10), so
 * the step 6 page does not carry the workspace copy for every Pro Buyer.
 */
export const ProjectFavoritesCountSlot = ({ count }: { count?: number }) =>
  useProWorkspace().enabled && count !== undefined ? (
    <ProjectFavoritesCount count={count} />
  ) : null;
